import { KsaCity } from '~/types/ksa/KsaCity';
import axios from './axios';

export const getKsaCities = () => {
  return axios.get<KsaCity[]>('/misc/ksa/cities').then((res) => res.data);
};
